import * as moment from "moment";

const pad2Numbers = (num: number): string => {
  let str = num.toString();
  if (str.length < 2) {
    str = "0" + str;
  }
  return str;
}

const formatDate = (date: Date|string|moment.Moment): string => {
  const momentDate: moment.Moment = moment(date);
  let formattedDate = dateFormat();

  formattedDate = formattedDate.replace('dd', pad2Numbers(momentDate.date()));
  formattedDate = formattedDate.replace('MM', pad2Numbers(momentDate.month() + 1));
  formattedDate = formattedDate.replace('yyyy', momentDate.year().toString());

  return formattedDate;
};

const formatDateTime = (date: Date|string|moment.Moment): string => {
  const momentDate: moment.Moment = moment(date);
  const dateFormatString = formatDate(date);
  let formattedTime = timeFormat();
  const isAMPM = formattedTime.indexOf('aa') > 0;
  const hours = isAMPM && momentDate.hours() > 12 ? momentDate.hours() - 12 : momentDate.hours();

  formattedTime = formattedTime.replace('hh', pad2Numbers(hours));
  formattedTime = formattedTime.replace('HH', pad2Numbers(hours));
  formattedTime = formattedTime.replace('h', hours.toString());
  formattedTime = formattedTime.replace('mm', pad2Numbers(momentDate.minutes()));
  formattedTime = formattedTime.replace('aa', momentDate.hours() < 12 ? "AM" : "PM");

  return `${dateFormatString} ${formattedTime}`;
};

const dateFormat = (): string => {
  const sampleDate = new Date(2000, 10, 15, 20, 30, 40);
  let strDateFormat = sampleDate.toLocaleDateString();

  strDateFormat = strDateFormat.replace(sampleDate.getDate().toString(), "dd");
  strDateFormat = strDateFormat.replace((sampleDate.getMonth() + 1).toString(), "MM");
  strDateFormat = strDateFormat.replace(sampleDate.getFullYear().toString(), "yyyy");
  return strDateFormat;
}

const timeFormat = (): string => {
  const sampleDate = new Date(2000, 10, 15, 20, 30, 40);
  const strTimeFormat = sampleDate.toLocaleTimeString();
  let tSep = '';
  if (strTimeFormat.indexOf(":") > 0) {
    tSep = ':';
  }
  if (strTimeFormat.indexOf(".") > 0) {
    tSep = '.';
  }
  if (["M", "m"].some(amPm => strTimeFormat.includes(amPm))) {
    if (tSep === '') {
      return `hhmm aa`;
    } else {
      return `h${tSep}mm aa`;
    }
  }
  return `HH${tSep}mm`;
}

export const DateUtil = {
  formatDate,
  formatDateTime,
  dateFormat,
  timeFormat,
};
